import { useTranslation } from "react-i18next";

/**
 * Route planner.
 *
 * The planning pipeline (Directions fetch, corridor search, leg splitting)
 * already ships in infra/contracts/route-planning.ts and
 * src/features/routePlanning. This page is intentionally inert until a Mapbox
 * token with the Directions scope is available to exercise it against a live
 * route — a tab that silently fails would be worse than one that says what it
 * is waiting for.
 */
export function RoutePlannerRoute() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 text-center">
      <h1 className="text-2xl font-bold text-fg">{t("route_planner.title")}</h1>
      <p className="mx-auto mt-4 max-w-prose text-sm leading-relaxed text-fg-mute">
        {t("route_planner.coming_soon")}
      </p>
    </div>
  );
}
